<template>
    <div>
        <!-- :inline="true" -->
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-date-picker v-model="createTime" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" align="left"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']" @change="dateChange"></el-date-picker>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input v-model="query.content" placeholder="昵称/邮箱地址" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable style="width:250px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
            <br />
            <!-- 下拉框 -->
            <el-form-item class="query-form-item">
                <el-select v-model="query.userregistype" style="width:150px" placeholder="注册方式" @change="onSubmit" clearable>
                    <el-option label="不限" value="-1"></el-option>
                    <el-option label="邮箱注册" value="0"></el-option>
                    <el-option label="Facebook注册" value="1"></el-option>
                    <el-option label="Linkedin注册" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.enterprise" style="width:150px" placeholder="完善企业信息" @change="onSubmit" clearable>
                    <el-option label="不限" :value="-1"></el-option>
                    <el-option label="是" :value="0"></el-option>
                    <el-option label="否" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.countryId" style="width:150px" placeholder="国家/地区" @change="onSubmit" clearable filterable>
                    <el-option label="全部" :key="0" :value="0"></el-option>
                    <el-option v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.activity" style="width:150px" placeholder="是否活跃" @change="onSubmit" clearable>
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="活跃" :value="0"></el-option>
                    <el-option label="非活跃" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="position: absolute;right: 10px;" class="query-form-item">
              <el-button type="primary" icon="el-icon-edit" @click.native="insertCustomer">提交用户</el-button>
              <el-button type="primary" icon="el-icon-edit" @click.native="getCustomer">拉取用户</el-button>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null, null)">添加</el-button>
                <el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel()">导出</el-button>
                <el-upload class="upload-btn" :action="uploadAction" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :on-error="handleAvatarError" :before-upload="uploadLoadings"
                    accept=".xls, .xlsx" multiple>
                    <el-button size="small" type="primary" icon="el-icon-upload2">导入</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column type="selection" width="50" fixed />
            <el-table-column label="头像" prop="userpic" align="center">
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        <img :src="scope.row.userpic" style="width:400px;border-radius:3px;" />
                        <img slot="reference" :src="scope.row.userpic"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="昵称" prop="usernick" align="center" />
            <el-table-column label="邮箱地址" prop="useremail" width="200" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.useremail == null">-</span>
                    <span v-if="scope.row.useremail != null">{{scope.row.useremail}}</span>
                </template>
            </el-table-column>

            <el-table-column label="等级" prop="usergrade" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.usergrade == null">-</span>
                    <span v-if="scope.row.usergrade != null">{{scope.row.usergrade}}</span>
                </template>
            </el-table-column>

            <el-table-column label="积分" prop="userintegral" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.userintegral == null">-</span>
                    <span v-if="scope.row.userintegral != null">{{
                        scope.row.userintegral
                    }}</span>
                </template>
            </el-table-column>

            <el-table-column label="注册方式" prop="userregistype" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.userregistype == 0">邮箱注册</span>
                    <span v-if="scope.row.userregistype == 1">Facebook注册</span>
                    <span v-if="scope.row.userregistype == 2">Linkedin注册</span>
                </template>
            </el-table-column>

            <el-table-column label="登录IP" prop="userip" align="center" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.userip == null">暂无IP</span>
                    <span v-if="scope.row.userip != null">{{
                        scope.row.userip
                    }}</span>
                </template>
            </el-table-column>

            <el-table-column label="登录时间" prop="userregistertime" align="center" width="230">
                <template slot-scope="scope">
                    <span v-if="scope.row.userregistertime != null">
                        <i class="el-icon-time"></i>
                        {{
                            scope.row.userregistertime
                                | formatDateStr("yyyy-MM-dd hh:mm:ss")
                        }}
                    </span>
                    <span v-if="scope.row.userregistertime == null">-</span>
                </template>
            </el-table-column>

            <el-table-column label="登录设备" prop="" align="center" width="230">
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.userregistertime != null">
            <i class="el-icon-time"></i>
            {{
            scope.row.userregistertime | formatDateStr("yyyy-MM-dd hh:mm:ss")
            }}
          </span>
          <span v-if="scope.row.userregistertime == null">-</span> -->
                </template>
            </el-table-column>

            <el-table-column label="操作" width="301" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain @click.native="
                            detailForm1(
                                scope.row.userid,
                                scope.row.usersuperiorid
                            )
                        ">查看</el-button>
                    <el-button type="primary" size="mini" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.row.userid)">删除</el-button>
                    <el-button type="warning" size="mini" @click.native="
                            handleBan(scope.row.userban, scope.row.userid)
                        ">
                        {{
                            scope.row.userban == 0 ? "禁止登录" : "解除禁封"
                        }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            :current-page="query.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>
        <!-- </el-scrollbar> -->
        <!--表单-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="800px"
            top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="昵称" prop="usernick">
                    <el-input v-model="formData.usernick" placeholder="请输入昵称" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮箱地址" prop="useremail">
                    <el-input v-model="formData.useremail" placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-form-item label="登录密码" prop="userpassword">
                    <el-input v-model="formData.userpassword" type="password" placeholder="请输入登录密码" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPassword" v-if="formName == 'add'">
                    <el-input type="password" v-model="formData.checkPassword" placeholder="请再次输入密码" auto-complete="off"
                        clearable></el-input>
                </el-form-item>
                <el-form-item class="query-form-item" label="专属客服" prop="compellation">
                    <el-select v-model="formData.compellation" placeholder="请选择" style="width:150px" clearable>
                        <el-option v-for="(item, index) in serList" :key="index" :label="item.compellation"
                            :value="item.compellation"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
        <!--查看弹框-->
    </div>
</template>

<script>
    import {
        getList,
        saveMbUser,
        relogin,
        userdelete,
        getListAll,
        editUserBan,
        getCountry, // 获取国家
        userExcel, // 导入文件
        insertUser,
        getUser
    } from "../../api/mbUser/mbUser";
    import {BASE_URL} from "../../config/app";
    import {edit} from "../../api/setting/comRate";
    const formJson = {
        usernick: "",
        emailaddress: "",
        userpassword: "",
        userid: "",
        userregistype: ""
    };
    export default {
        data() {
            let validatlogin = (rule, value, callback) => {
                let data = {
                    relogin: value,
                    userid: this.formData.userid
                };
                relogin(data)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.isrelogin = response.data;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
                if (this.isrelogin > 0 && this.formName == "add") {
                    callback(new Error("账号已存在"));
                }
                callback();
            };
            let validatePass3 = (rule, value, callback) => {
                if (this.formData.userpassword !== "" && value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.formData.userpassword) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            let emailaddress = (rule, value, callback) => {
                const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if (value == "" || value == undefined || value == null) {
                    callback();
                } else {
                    if (!reg.test(value)) {
                        callback(new Error("请输入正确的邮箱地址"));
                    } else {
                        callback();
                    }
                }
            };
            return {
                pickerOptions: {
                    shortcuts: [{
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近六个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 180
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                options: [],
                selectedOptions: [],
                labelPosition: "right",
                isrelogin: "",
                cancelToggle: false,
                createTime: [],
                query: {
                    startTime: "",
                    endTime: "",
                    content: "",
                    currentPage: 1,
                    pageSize: 10,
                    userid: "",
                    enterprise: "",
                    countryId: "",
                    activity: "",
                    userregistype: ""
                },
                address: [],
                grades: [],
                divLoading: "",
                list: [],
                serList: [],
                mbUserSer: [],
                supername: "",
                selectedCity: [],
                firstDeparts: [],
                // hospitalnamelist: [], //添加主管医院的集合
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formMap: {
                    add: "添加",
                    edit: "编辑",
                    detail: "详情"
                },
                cascaderConfig: {
                    label: "othersecondname",
                    value: "secondid",
                    children: "children"
                },
                gradeVisible: false,
                lineVisible: false,
                formLoading: false,
                formVisible: false,
                detailVisible: false,
                formData: formJson,
                formRules: {
                    usernick: {
                        required: true,
                        message: "请输入昵称",
                        trigger: "blur"
                    },
                    userpassword: {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    },
                    checkPassword: [{
                            required: true,
                            message: "请再次输入密码",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass3,
                            trigger: "blur"
                        }
                    ],
                    useremail: [{
                            required: true,
                            message: "请输入邮箱",

                            trigger: "blur"
                        },
                        {
                            validator: emailaddress
                        },
                        {
                            validator: validatlogin,
                            trigger: "down"
                        }
                    ],
                    compellation: {
                        required: true,
                        message: "请选择专属客服",
                        trigger: "blur"
                    }
                },
                multipleSelection: [], //多选集合,
                countrys: [], // 国家数组
                uploadAction: BASE_URL + "/mbUser/userExcel" // "http://192.168.1.237:18080/mbUser/userExcel"
            };
        },
        methods: {
          //提交用户数据到三方销客系统上
          insertCustomer(){
            insertUser().then(response => {})
            .catch((err) => {
              console.log('err',err)
            });
            setTimeout(()=>{
              this.$message.success("提交成功");
            },1000)
          },
          //拉取三方销客系统用户数据到本系统上
          getCustomer(){
            getUser().then(response => {
              this.onRest()
            });
            setTimeout(()=>{
              this.$message.success("拉取成功");
            },2000)
          },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.userid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
                this.handleBan(ids);
            },
            onRest() {
                Object.assign(this.query, this.$options.data().query)
                this.createTime = [];
                this.getList();
            },
            onSubmit() {
                this.query.currentPage = 1;
                // this.$router.push({
                //     path: ""
                //     //query: this.query
                // });
                this.getList(1);
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList(1);
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList(1);
            },
            //跳转详情页面
            detailForm1(userid, usersuperiorid) {
                this.$router.push({
                    path: "/mbUser/Detail",
                    query: {
                        userid: userid,
                        usersuperiorid: usersuperiorid
                    }
                });
            },
            getList() {
                this.loading = true;
                getList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            getListAll() {
                getListAll(this.query)
                    .then(res => {
                        this.serList = res.data || [];
                    })
                    .catch(() => {});
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.formData.compellation = ""; //清空专属客服
                return true;
            },
            // 隐藏详情弹框
            hideDetailForm() {
                // 更改值
                this.detailVisible = !this.detailVisible;
                return true;
            },

            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                this.formName = "add";
                // 编辑
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },
            //显示 查看弹框
            detailForm(index, row) {
                if (row !== null) {
                    this.detailVisible = true;
                    this.formData = Object.assign({}, row);
                    this.formName = "detail";
                }
                this.getUserAddress();
                this.getSuperNameBySuperId();
            },
            //禁止登录
            handleBan(type, ids) {
                if (ids) {
                    let data = {
                        id: ids,
                        type: type
                    };
                    editUserBan(data)
                        .then(response => {
                            if (response.code) {
                                this.$message.error(response.message);
                            }
                            this.$message.success("操作成功");
                            this.getList();
                            setTimeout(() => {
                                this.loading = false;
                            }, 0.3 * 1000);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            params.append("ids", ids);
                            userdelete(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            // 导出
            exportExcel() {
                window.location.href = BASE_URL + "/mbUser/export";
            },
            formSubmit() {
                delete this.formData.usercompany;
                delete this.formData.userregistertime;
                delete this.formData.userregisttime;
                delete this.formData.userregistype;
                delete this.formData.userpic;
                delete this.formData.userip;
                delete this.formData.usertel;
                delete this.formData.userwebsite;
                delete this.formData.userfacebookid;
                delete this.formData.userfacebooktokne;
                delete this.formData.userlinkedinid;
                delete this.formData.userlinkedintoken;
                delete this.formData.usercompany;
                delete this.formData.usercpany;
                delete this.formData.userserviceid;
                delete this.formData.usersuperiorid;
                delete this.formData.usermobile;
                delete this.formData.mbIntegralList;
                delete this.formData.usergradesort;
                delete this.formData.userday;
                delete this.formData.userminute;
                delete this.formData.usermonth;
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;

                         //var params = new URLSearchParams(this.formData);
                        // console.log(params);
                          var params = this.formData;
                       // console.log(params);
                        saveMbUser(params, this.formName).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            this.formVisible = false;
                            // 清空表单
                            this.$refs["dataForm"].resetFields();
                            this.formData.compellation = ""; //清空专属客服
                            // 加载表格数据
                            this.getList();
                        });
                    }
                });
            },
            // 获取国家
            getCountry() {
                getCountry({})
                    .then(res => {
                        this.countrys = res.data || [];
                    })
                    .catch(() => {
                        this.countrys = [];
                    });
            },
            // 文件导入
            uploadLoadings() {
                this.loading = true;
            },
            handleAvatarSuccess(response) {
                if (response.code) {
                    this.$message.error(response.message);
                    return false;
                }
                this.$message.success("导入成功");
                // this.getList();
            },
            handleAvatarError() {
                this.$message.error("上传文件出错");
            }
        },

        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
            this.getListAll();
            this.getCountry(); // 获取国家
        }
    };

</script>

<style type="text/scss" lang="scss"></style>
